require('./CollapseItem.scss');
require('./_Multichannel/CollapseItem_Multichannel.scss');

const b = require('app/www/libs/b')('collapse-item');

const React = require('react');
const PropTypes = require('prop-types');
const Icon = require('app/www/components/blocks/Icon/Icon');

class CollapseItem extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: this.props.isOpen,
        };

        this._onClick = this._onClick.bind(this);
    }

    componentDidMount() {
        this._height = this._holder.offsetHeight;
    }

    render() {
        const {item, isOnlyOne} = this.props;
        const {isOpen} = this.state;

        const mods = Object.assign({}, this.props.mods, {
            show: isOpen,
        });

        const iconProps = {
            mods: {
                size: 'm',
                arrow: true,
            },
        };

        if (this._height && this._height < this._holder.offsetHeight) {
            this._height = this._holder.offsetHeight;
        }

        const style = {
            maxHeight: isOpen ? (`${this._height}px` || 'auto') : 0,
        };

        return (
            <div className={b(mods)}>
                <div className={b('header')}>
                    {isOnlyOne && item.header}
                    {!isOnlyOne && (
                        <div className={b('control')} onClick={this._onClick}>
                            <Icon className={b('icon')} {...iconProps} />
                            {item.header}
                        </div>
                    )}
                </div>
                <div className={b('description')} style={style}>
                    <div className={b('holder')} ref={ref => (this._holder = ref)}>
                        {item.description}
                    </div>
                </div>
            </div>
        );
    }

    _onClick() {
        const {
            item,
            openItem,
        } = this.props;

        this.setState({
            isOpen: !this.state.isOpen,
        });

        openItem(item.id, item.orderIndex);
    }

}

CollapseItem.propTypes = {
    item: PropTypes.shape({
        header: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object,
        ]).isRequired,
        description: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.object,
        ]),
        id: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
        ]).isRequired,
        metrikaParams: PropTypes.object,
    }),
    isOpen: PropTypes.bool,
    isOnlyOne: PropTypes.bool,
    openItem: PropTypes.func,
};

module.exports = CollapseItem;
